import { Error } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { GoogleMap, GoogleMapProps, MarkerF } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import styles from './MapWithMarker.module.scss';
interface MapProps {
    address?: string;
    customHeight?: string;
}

export function MapWithMarker({ address, customHeight }: MapProps) {
    const [position, setPosition] = useState<GoogleMapProps['center'] | null>(
        null
    );

    useEffect(() => {
        if (window.google?.maps && address) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder
                .geocode({ address })
                .then((res) => {
                    const pos = res.results[0].geometry.location;
                    setPosition(pos);
                })
                .catch((_) => setPosition(null));
        } else if (!address) setPosition(null);
    }, [address]);

    return !position ? (
        <div className={`${styles.map} ${styles.mapMissing}`}>
            <Chip
                icon={<Error color="error" />}
                label="Map will not render, invalid address provided."
                color="error"
            />
        </div>
    ) : (
        <GoogleMap
            zoom={12}
            mapContainerClassName={styles.map}
            mapContainerStyle={{ minHeight: customHeight ?? '250px' }}
            center={position}
            options={{
                clickableIcons: false,
                disableDefaultUI: true,
                disableDoubleClickZoom: true,
                fullscreenControl: false,
                gestureHandling: 'none',
            }}
        >
            <MarkerF position={position} visible />
        </GoogleMap>
    );
}
